export default __webpack_public_path__ + "7b3bd9ec6eb92d59bb39eb7519fc60a5.svg";